import { TThunkAction } from '../../types/redux';

export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  onSuccess?(): TThunkAction;
  onCloseNoAuth?(): TThunkAction;
}

export interface IAuthenticateEvent {
  autoRefresh?: boolean;
}
